/**
 * Income reference age must fall between the client's current age and the end
 * of their predicted long-term care period. Returns an error string when the
 * value is out of bounds, or `undefined` when valid (or not applicable).
 */
export function validateIncomeReferenceAge({
  value,
  isIncomeStream,
  currentAge,
  ltcEndAge,
}: {
  value: number | null | undefined;
  isIncomeStream: boolean;
  currentAge: number | null;
  ltcEndAge: number | null | undefined;
}): string | undefined {
  if (!isIncomeStream) return undefined;
  if (typeof value !== 'number') return undefined;
  if (currentAge != null && value < currentAge) {
    return `Must be at least ${currentAge} (current age)`;
  }
  if (ltcEndAge != null && value > ltcEndAge) {
    return `Must be at most ${ltcEndAge} (end of care)`;
  }
  return undefined;
}
